import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "../../../shared/hooks/useWindowSize";
import { Button, Card, CardContent, Grid, TextField, Typography, Autocomplete, Checkbox, Box } from "@mui/material";
import { workshopCardStyle } from "../../../shared/styles/cardStyles";
import { altChooseButtonStyleTurquoise } from "../../../shared/styles/buttonStyles";
import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';
import carBrandContext from "../../../app/providers/car-brands/carBrandContext";
import { useNavigate } from "react-router-dom";
import FragusImage from "../../../assets/images/fragus.png";
import UserLocationV2 from "./UserLocationV2";
import { useGetCarBrandsQuery } from "../../../app/store/api/carsApi";

export default function HeroSearch() {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const { state: carBrandState, setBrand, clearBrand } = useContext(carBrandContext);

    const { isMobile, isTablet, isDesktop } = useWindowSize();
    const {data:brands, isLoading: brandsLoading} = useGetCarBrandsQuery();

    const Fragus = () => {
        return (
            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '14px'
            }}>
                <Checkbox
                   checked={false}
                   onChange={() => { }}
               />
                <Typography variant="body2" component="div" sx={{ fontSize: '12px', color: 'grey', fontSize: isDesktop ? '1.1rem' : '0.8rem' }}>
                    {t('hero.fragusInsurance')}
                </Typography>
                <img src={FragusImage} alt="Fragus" style={{ height: '24px', margin: '0 8px' }} />
                {/* <p>turvavakuutus</p> */}
            </Box>
        )
    }

    if (isMobile || isTablet) {
        return (
            <Box className="hero-search-mobile"
                sx={{ 
                    marginTop: '20px', 
                    marginBottom: '20px', 
                    padding: '20px',
                    width: '100%',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    <Box>
                        <Typography variant="body2" component="div" sx={{ marginBottom: '8px', fontSize: '14px', fontWeight: 'bold' }}>
                            {t('hero.location')}
                        </Typography>
                        <Typography variant="caption" component="div" sx={{ marginBottom: '8px', fontSize: '12px', color: 'grey' }}>
                            {t('hero.locationSubtext')}
                        </Typography>
                        <UserLocationV2 brandsLoading={brandsLoading} />
                    </Box>
                    <Box>
                        <Typography variant="body2" component="div" sx={{ marginBottom: '8px', fontSize: '14px', fontWeight: 'bold' }}>
                            {t('hero.carBrand')}
                        </Typography>
                        <Typography variant="caption" component="div" sx={{ marginBottom: '8px', fontSize: '12px', color: 'grey' }}>
                            {t('hero.carBrandSubtext')}
                        </Typography>
                        <Autocomplete
                            options={brands ? brands : []}
                            getOptionLabel={(option) => option?.name || ""}
                            getOptionKey={(option) => option?.id}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            value={carBrandState?.brand || null}
                            disabled={brandsLoading}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setBrand(newValue);
                                } else {
                                    clearBrand();
                                }
                            }}
                            renderInput={(params) => (
                                <TextField {...params} placeholder={t('hero.carBrandName')} fullWidth />
                            )}
                        />
                    </Box>
                    <Button
                        sx={{...altChooseButtonStyleTurquoise, padding: '12px'}}
                        startIcon={<SearchIcon />}
                        fullWidth
                        size="large"
                        disabled={brandsLoading}
                        onClick={() => navigate('/workshoplist')}
                    >
                        {t('actions.searchWorkshops')}
                    </Button>
                </Box>
                <Fragus />
            </Box>
        );
    }

    return (
        <Card className="hero-search-card"
            sx={{...workshopCardStyle, marginTop: '20px', marginBottom: '20px', padding: '10px', width: '100%'}}
        >
            <CardContent>
                <Grid container spacing={2} alignItems="center" justifyContent="center">
                    <Grid
                        size={{ xs: 5, sm: 4, md: 5, lg: 5 }}
                    >
                        <Typography variant="body2" component="div" sx={{ textAlign: 'center', marginBottom: '8px', fontSize: '14px', fontWeight: 'bold' }}>
                            {t('hero.location')}
                        </Typography>
                        <Typography variant="caption" component="div" sx={{ textAlign: 'center', marginBottom: '8px', fontSize: '12px', color: 'grey' }}>
                            {t('hero.locationSubtext')}
                        </Typography>
                    </Grid>
                    <Grid
                        size={{ xs: 5, sm: 4, md: 5, lg: 5 }}
                    >
                        <Typography variant="body2" component="div" sx={{ textAlign: 'center', marginBottom: '8px', fontSize: '14px', fontWeight: 'bold' }}>
                            {t('hero.carBrand')}
                        </Typography>
                        <Typography variant="caption" component="div" sx={{ textAlign: 'center', marginBottom: '8px', fontSize: '12px', color: 'grey' }}>
                            {t('hero.carBrandSubtext')}
                        </Typography>
                    </Grid>
                    <Grid
                        size={{ xs: 2, sm: 4, md: 2, lg: 2 }}
                    >

                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="stretch" justifyContent="center">
                    <Grid
                        size={{ xs: 5, sm: 4, md: 5, lg: 5 }}
                    >
                        <UserLocationV2 brandsLoading={brandsLoading} />
                    </Grid>
                    <Grid
                        size={{ xs: 5, sm: 4, md: 5, lg: 5 }}
                    >
                        <Autocomplete
                            options={brands ? brands : []}
                            getOptionLabel={(option) => option?.name || ""}
                            getOptionKey={(option) => option?.id}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            value={carBrandState?.brand || null}
                            disabled={brandsLoading}
                            onChange={(event, newValue) => {
                                if (newValue) {
                                    setBrand(newValue);
                                } else {
                                    clearBrand();
                                }
                            }}
                            renderInput={(params) => (
                                <TextField {...params} placeholder={t('hero.carBrandName')} fullWidth />
                            )}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 2, sm: 4, md: 2, lg: 2 }}
                    >
                        <Button
                            sx={{...altChooseButtonStyleTurquoise, minWidth: '100px', height: '100%', fontSize: '0.8rem'}}
                            startIcon={<SearchIcon />}
                            fullWidth
                            disabled={brandsLoading}
                            onClick={() => navigate('/workshoplist')}
                        >
                            {t('actions.searchWorkshops')}
                        </Button>
                    </Grid>
                </Grid>
                <Fragus />
            </CardContent>
        </Card>
    );
}